/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Directory_Builders_Product_CountInputs */

const en_directory_builders_product_count = /** @type {(inputs: Directory_Builders_Product_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} products`)
};

const zh_directory_builders_product_count = /** @type {(inputs: Directory_Builders_Product_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 个产品`)
};

/**
* | output |
* | --- |
* | "{count} products" |
*
* @param {Directory_Builders_Product_CountInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_builders_product_count = /** @type {((inputs: Directory_Builders_Product_CountInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Builders_Product_CountInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_builders_product_count(inputs)
	return zh_directory_builders_product_count(inputs)
});
export { directory_builders_product_count as "directory.builders.product_count" }